// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__25b5C","inner":"Form_inner__2n-mK","range":"Form_range__18daa","name":"Form_name__3DfQ_","actions":"Form_actions__3vQnS"};